export class DateTime {
  static getLocalDate = function (jsonDate: string | number | Date | undefined | null) {
    return jsonDate ? new Date(jsonDate).toLocaleDateString() : null;
  };
}
